import script from "./TeacherRatingDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherRatingDialog.vue?vue&type=script&setup=true&lang=js"

import "./TeacherRatingDialog.vue?vue&type=style&index=0&id=9b196a9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b196a9a"]])

export default __exports__